import { bootstrapApplication } from '@angular/platform-browser';
import { EvoltiAppConfig } from './app/evoltiAppConfig';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, EvoltiAppConfig).catch((err) => console.error(err));
